export const review = {
  uz: {
    reviewTitle: "Mijozlarimizdan Sharhlar",
    mainReviewTitle: "Bemorlarimizning <span>sharhlari</span>",
    mainReviewText:
      "Sizning samimiy sharhlaringiz va fikrlaringiz – biz uchun muhim <br/> Har bir fikringiz klinikamizni yanada takomillashtirishimizgaga sabab bo’ladi",
    mainReviewLinkText: "Barcha sharhlarni ko'rish",
  },
  ru: {
    reviewTitle: "Отзывы Наших Клиентов",
    mainReviewTitle: "<span>Отзывы</span> наших пациентов",
    mainReviewText:
      "Ваши искренние отзывы и мнения для нас бесценны <br/> Благодаря каждому отзыву мы улучшаем сервис и уровень лечения",
    mainReviewLinkText: "Посмотреть все отзывы",
  },
  tj: {
    reviewTitle: "Фикру Мулоҳизаҳои Муштариени Мо",
    mainReviewTitle: "<span>Фикру мулоҳизаҳои</span> мо",
    mainReviewText:
      "Шишаҳои сафеда ба фурӯш баромаданд. Дар Бораи Лоренсо хавотир нашавед, танҳо баланд хандед",
    mainReviewLinkText: "Дидани ҳамаи шарҳҳо",
  },
};
